export type DisplayNameProfile =
  | {
      displayName?: string | null;
      username?: string | null;
    }
  | null
  | undefined;

export function displayNameOf(profile: DisplayNameProfile): string {
  const displayName = profile?.displayName?.trim();
  if (displayName) {
    return displayName;
  }

  return profile?.username?.trim() || "";
}

export function initialsOf(profile: DisplayNameProfile): string {
  const displayName = displayNameOf(profile);
  if (!displayName) {
    return "U";
  }

  return displayName.slice(0, 2).toUpperCase();
}
